import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './Main';
import { ThemeProvider } from './contexts/ThemeContext';
import './bootstrap';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
